module.exports = __webpack_public_path__ + "img/dark_brown.7498dca5.svg";